const experimental_createTheme = (themeParams) => {
  return {
    ...themeParams,
    __type: "prebuilt_appearance"
  };
};
export {
  experimental_createTheme
};
